module.exports = __webpack_public_path__ + "img/volley-uster.28157960.svg";